/**
 * TODO: This masking only works with with one separator for now. When we add more countries,
 *       it would be worth looking into using a 3rd party solution for the masking logic.
 */
const inputMaskConfig = {
  au: {
    mask: '9999',
    separator_char: '',
  },
  br: {
    mask: '99999-999',
    separator_char: '-',
  },
  se: {
    mask: '999 99',
    separator_char: ' ',
  },
};

export const getInputMaskByCountry = (countryCode) => inputMaskConfig[countryCode.toLowerCase()];

export const putMaskOn = (countryCode, userInput) => {
  if (countryCode && userInput) {
    const { mask, separator_char } = getInputMaskByCountry(countryCode.toLowerCase());

    if (!mask) {
      return userInput;
    }

    const separatorPos = mask.indexOf(separator_char);

    const pattern = new RegExp(separator_char, 'g');
    userInput = userInput.replace(pattern, '');

    if (
      separatorPos !== -1 &&
      (userInput.charAt(separatorPos) === separator_char ||
        userInput.length < mask.substring(0, separatorPos).length)
    ) {
      return userInput;
    }

    const firstSegment = userInput.substring(0, separatorPos);
    const secondSegment = userInput.substring(separatorPos);

    const maskedInput =
      firstSegment + (secondSegment.length > 0 ? separator_char + secondSegment : '');

    return maskedInput;
  }
};

export const stripMaskFrom = (countryCode, userInput) => {
  if (countryCode && userInput) {
    const { separator_char } = getInputMaskByCountry(countryCode.toLowerCase());
    if (separator_char) {
      const regex = new RegExp(separator_char, 'gi');
      userInput = userInput.replace(regex, '');
    }
    return userInput;
  }
};
